import React from 'react'
import { observer } from 'mobx-react'
import Radio, { Option } from '@Components/Fields/Radio'

interface RepresentativeDetailsProps {
    setRepresentation: (id: number) => void
}

const RepresentativeDetails = (props: RepresentativeDetailsProps) => {
    const { setRepresentation } = props

    const setRepresentationOption = (data: Option) => {
        setRepresentation(data.id)
    }

    return (
        <>
            <div className="representation-container">
                <h5 className="medium subtitle">
                    You should only create a publisher if you administer the shares for that entity.
                </h5>
                <h5 className="medium subtitle">Do you administer the shares for the entity you wish to create?</h5>
                <Radio
                    field={{ name: 'representation' }}
                    options={[
                        { id: 1, value: 'yes', label: 'Yes, I administer the shares for this entity' },
                        {
                            id: 2,
                            value: 'no',
                            label: 'No, I do not administer the shares.',
                        },
                    ]}
                    onChange={setRepresentationOption}
                    defaultCheckedId={1}
                />
            </div>
        </>
    )
}

export default observer(RepresentativeDetails)
